import { z } from "zod";
import { passwordValidation } from "../../constants/regex";
import { zEmailSchema, zNumber, zString } from "./commonSchemaObjects";

export const userRegistrationSchema = z
  .object({
    first_name: zString.zRequired,
    last_name: zString.zRequired,
    email: zEmailSchema,
    password: zString.zRequired
      .min(8, "Password should have minimum 8 characters")
      .regex(passwordValidation, "Password is not in expected format"),
    number: zNumber.zOptional.or(z.literal("")),
    confirmPassword: zString.zRequired
      .min(8, "Password should have minimum 8 characters")
      .regex(passwordValidation, "Password is not in expected format"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });
